export default __webpack_public_path__ + "static/media/upArrow.fa973f6a.svg";